import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-logo">
            <picture>
              {/* WebP version for browsers that support it */}
              <source 
                srcSet="/images/optimized/translate-stocks-logo-light-200.webp 200w, 
                        /images/optimized/translate-stocks-logo-light-120.webp 120w"
                sizes="(max-width: 768px) 120px, 200px"
                type="image/webp"
              />
              {/* PNG fallback for browsers that don't support WebP */}
              <source 
                srcSet="/images/optimized/translate-stocks-logo-light-200.png 200w, 
                        /images/optimized/translate-stocks-logo-light-120.png 120w"
                sizes="(max-width: 768px) 120px, 200px"
                type="image/png"
              />
              <img 
                src="/images/translate-stocks-logo-light.png" 
                alt="Translate Stocks Logo" 
                width="200" 
                height="45"
                loading="lazy"
                style={{
                  maxWidth: '100%',
                  height: 'auto'
                }}
              />
            </picture>
            <p className="footer-tagline">
              Next-generation AI-powered trading platform
            </p>
          </div>
          
          <div className="footer-nav">
            <div className="footer-nav-column">
              <h4>Platform</h4>
              <ul>
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/price-on-rails">Price on Rails</Link></li>
                <li><Link to="/demo">Agentic Bot</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                {/* <li><Link to="/security">Security</Link></li> */}
              </ul>
            </div>
            
            <div className="footer-nav-column">
              <h4>Resources</h4>
              <ul>
                <li><Link to="https://api.translatestocks.com/">API</Link></li>
                <li><Link to="/documentation">Documentation</Link></li>
                <li><Link to="/documentation#idocs_charts">TS Studio Charts</Link></li>
                <li><a href="https://www.translatestocks.com/start">Web Dashboard</a></li>
                {/* <li><Link to="/faq">FAQ</Link></li> */}
              </ul>
            </div>
            
            <div className="footer-nav-column">
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                {/* <li><Link to="/press">Press</Link></li> */}
                <li><Link to="/about">About</Link></li>
              </ul>
            </div>
            
            <div className="footer-nav-column">
              <h4>Connect</h4>
              <div className="social-links">
                <a href="https://x.com/translatestocks" target="_blank" rel="noopener noreferrer" aria-label="X">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.3 2H21L13.5 10.5L22 22H15.9L10.7 15.2L4.6 22H1L9 13L1 2H7.3L12.9 8.2L17.3 2ZM16.2 20H17.8L6.5 4H4.8L16.2 20Z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://instagram.com/translatestocks" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 2 .3 2.7.7.7.4 1.3 1 1.7 1.7.4.7.6 1.5.7 2.7.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 2-.7 2.7-.4.7-1 1.3-1.7 1.7-.7.4-1.5.6-2.7.7-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-2-.3-2.7-.7-.7-.4-1.3-1-1.7-1.7-.4-.7-.6-1.5-.7-2.7C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-2 .7-2.7.4-.7 1-1.3 1.7-1.7.7-.4 1.5-.6 2.7-.7C8.4 2.2 8.8 2.2 12 2.2m0-2.2C8.7 0 8.3 0 7 .1 5.6.2 4.5.5 3.5 1 .5 1.9.2 3.2.1 4.7 0 6.3 0 6.7 0 12s0 5.7.1 7.3c.1 1.5.4 2.8 1.3 3.7.9.9 2.2 1.2 3.7 1.3C8.3 24 8.7 24 12 24s3.7 0 5.3-.1c1.5-.1 2.8-.4 3.7-1.3.9-.9 1.2-2.2 1.3-3.7.1-1.5.1-1.9.1-7.3s0-5.7-.1-7.3c-.1-1.5-.4-2.8-1.3-3.7-.9-.9-2.2-1.2-3.7-1.3C15.7 0 15.3 0 12 0zM12 5.8a6.2 6.2 0 100 12.4 6.2 6.2 0 100-12.4zm0 10.2a4 4 0 110-8 4 4 0 010 8zm6.6-10.8a1.4 1.4 0 11-2.8 0 1.4 1.4 0 012.8 0z" fill="currentColor"/>
                  </svg>
                </a>

                <a href="https://www.linkedin.com/company/translate-stocks" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H6.5V10H9V17ZM7.7 8.7C6.8 8.7 6 7.9 6 7C6 6.1 6.8 5.3 7.7 5.3C8.6 5.3 9.4 6.1 9.4 7C9.5 7.9 8.7 8.7 7.7 8.7ZM18 17H15.5V13.9C15.5 12.7 14.7 12.1 14 12.1C13.3 12.1 12.5 12.7 12.5 13.9V17H10V10H12.5V11.2C12.9 10.4 13.9 9.8 14.9 9.8C16.4 9.8 18 11 18 13.4V17Z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://facebook.com/translatestocks" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2H14C12.6739 2 11.4021 2.52678 10.4645 3.46447C9.52678 4.40215 9 5.67392 9 7V10H6V14H9V22H13V14H16L17 10H13V7C13 6.73478 13.1054 6.48043 13.2929 6.29289C13.4804 6.10536 13.7348 6 14 6H17V2Z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://youtube.com/@translatestocks" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.58 7.19C21.44 6.62 21.16 6.08 20.78 5.63C20.39 5.17 19.9 4.82 19.35 4.58C17.77 4 12 4 12 4C12 4 6.23 4 4.65 4.58C4.1 4.82 3.61 5.17 3.22 5.63C2.84 6.08 2.56 6.62 2.42 7.19C2 8.87 2 12 2 12C2 12 2 15.13 2.42 16.81C2.56 17.38 2.84 17.92 3.22 18.37C3.61 18.83 4.1 19.18 4.65 19.42C6.23 20 12 20 12 20C12 20 17.77 20 19.35 19.42C19.9 19.18 20.39 18.83 20.78 18.37C21.16 17.92 21.44 17.38 21.58 16.81C22 15.13 22 12 22 12C22 12 22 8.87 21.58 7.19ZM10 15.5V8.5L15.5 12L10 15.5Z" fill="currentColor"/>
                  </svg>
                </a>
              </div>
              
                {/* <div className="app-downloads">
                <h4>Mobile App</h4>
                <div className="app-buttons">
                  <a href="https://apps.apple.com/app/translatestocks" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/images/app-store-badge.svg" 
                    alt="Download on the App Store" 
                    width="135" 
                    height="40"
                    loading="lazy"
                  />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.translatestocks" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/images/google-play-badge.svg" 
                    alt="Get it on Google Play" 
                    width="135" 
                    height="40"
                    loading="lazy"
                  />
                  </a>
                </div>
                </div> */}
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="legal-links">
            <Link to="/about">About</Link>
            <Link to="/terms-of-use">Terms of Use</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/disclaimers">Disclaimers</Link>
          </div>
          
          <p className="copyright">
            &copy; {currentYear} Translate Stocks. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
